import { type MCPServerInfo } from '../../types';

const AzureDevOpsServer: MCPServerInfo = {
  serverId: 'AZURE_DEVOPS',
  name: 'Azure DevOps',
  slug: 'azure-devops',
  description:
    'The MCP server for Azure DevOps, bringing the power of Azure DevOps directly to your agents. List projects, builds, repos, work items, test plans, wikis, and more.',
  source: {
    sourceType: 'LOCAL_PACKAGE',
    transport: 'STDIO',
    commandFunction: `(config) => ({
  command: 'npx',
  args: ['-y', '@azure-devops/mcp', config?.adoOrg || ''],
  env: {}
})`
  },
  authenticationType: 'NONE',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['adoOrg'],
    properties: {
      adoOrg: {
        type: 'string',
        description:
          'Azure DevOps organization name (e.g., "contoso" for dev.azure.com/contoso)',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default AzureDevOpsServer;
